import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { withRouter } from 'react-router-dom';
import { withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { MLLocalDateUtil } from 'ml-portals-util-js';

import MLPolicySummaryDetailsComponent from '../../Components/MLPolicySummaryDetailsComponent/MLPolicySummaryDetailsComponent';
import ActivitiesAndNotesComponent from '../../Components/ActivitiesAndNotesComponent/ActivitiesAndNotesComponent';

import metadata from './OpenActivities.metadata.json5';

class PolicyOpenActivities extends Component {
    static propTypes = {
        authHeader: PropTypes.shape({}).isRequired,
        fromAccountLanding: PropTypes.shape({
            policyDetailsData: PropTypes.shape({
                policyResponse: PropTypes.shape({
                    policyNumber: PropTypes.string
                }),
                getPolicyDetails: PropTypes.func.isRequired,
                getUpdateCountInfo: PropTypes.func.isRequired
            }),
            basePath: PropTypes.string
        }).isRequired
    };

    getCurrentTermPolicies = () => {
        const {
            fromAccountLanding: {
                policyDetailsData: { 
                    policyResponse: policy
                }
            }
        } = this.props;

        const policies = [];
        const periodsOrderedFromLast = _.orderBy(policy.periods, ['createTime_ML'], ['desc']);
        const flteredPeriods = periodsOrderedFromLast.find((period) => {
            const currentDate = new Date().setHours(0, 0, 0, 0);
            return currentDate >= MLLocalDateUtil.localDate2Date(period.effective_ML) && currentDate <= MLLocalDateUtil.localDate2Date(period.expiration_ML) 
        }) || policy.latestPeriod;
        policies.push(flteredPeriods);
        return policies;
    };

    getMetadataImplementation = () => {
        const {
            fromAccountLanding: {
                policyDetailsData: { 
                    policyResponse: policy
                }
            }
        } = this.props;

        const overrides = {
            policySummaryDetailsComponent: {
                policies: this.getCurrentTermPolicies(),
                dtoInfo: 'edge.capabilities.gateway.policy.dto.PolicyPeriodDTO',
                totalFees: policy.totalChanges_Ext,
                itemizedFees: policy.feesCosts_Ext,
                displayAlternativeTemplate: false
            },
            policyDetailsActivitiesContainer: {
                authHeader: this.props.authHeader,
                policyNumber: policy.policyNumber
            }
        };
        const resolvers = {
            resolveComponentMap: {
                MLPolicySummaryDetailsComponent,
                ActivitiesAndNotesComponent: ActivitiesAndNotesComponent
            }
        };
        return <MetadataContent uiProps={metadata.pageContent} overrideProps={overrides} {...resolvers} />;
    };

    render() {
        return this.getMetadataImplementation();
    }
}

export default withRouter(withViewModelService(withAuthenticationContext(PolicyOpenActivities)));
